import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import { Box, IconButton, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import { CustomizedBox } from "../../../Custom/CustomizedBox";
import { CustomizedTooltip } from "../../../Custom/CustomizedTooltip";
import PurchaseDeliveryAddressModal from "../../../UI/Modal/PurchaseDeliveryAddressModal";

import { useModal } from "../../../../hooks/use-modal";
import { useDisable } from "../../../../hooks/use-disable";
import { countryFormatter } from "../../../../utils/Formatter/Global";
import SubHeader from "../SubHeader";

type Props = {
  forceDisabled?: boolean;
};

const AddressInfo = ({ forceDisabled }: Props) => {
  const { t } = useTranslation();
  const [disabled] = useDisable();

  const { getValues } = useFormContext();

  const {
    modal: openDeliveryAddress,
    openModalHandler: openDeliveryAddressHandler,
    closeModalHandler: closeDeliveryAddress,
  } = useModal();

  const renderAddressString = () => {
    const addressValues = getValues(`delivery_address`);
    if (addressValues) {
      const {
        address_name,
        sub_district,
        district,
        province,
        postal_code,
        country,
      } = addressValues;

      const orderedValues = {
        address_name,
        sub_district,
        district,
        province,
        postal_code,
        country,
      };
      let result = "";

      if (addressValues && orderedValues) {
        if (Array.isArray(addressValues)) {
          addressValues.forEach((item) => {
            if (item?.length > 0) {
              result = result + item + ", ";
            }
          });
        } else {
          const keys = Object.keys(orderedValues);
          keys.forEach((key) => {
            let newValue = "";
            if (key === "country") {
              newValue =
                countryFormatter(
                  orderedValues[key as keyof typeof orderedValues]
                ) || "";
            } else {
              newValue = orderedValues[key as keyof typeof orderedValues];
            }

            if (newValue && newValue.length > 0) {
              result = result + newValue + ", ";
            }
          });
        }
        if (result?.trim().length === 0) {
          return "-";
        }
      }
      // remove whitespace and last comma
      return result?.trim().slice(0, -1);
      // remove whitespace and last comma
    } else return "-";
  };

  return (
    <Fragment>
      <CustomizedBox margin={0}>
        <Box display="flex" gap={1} alignItems="center">
          <SubHeader title={t("address.delivery_address")} />
          {!disabled ? (
            <CustomizedTooltip title={`แก้ไข${t("address.delivery_address")}`}>
              <IconButton onClick={openDeliveryAddressHandler} color="primary">
                <EditIcon />
              </IconButton>
            </CustomizedTooltip>
          ) : null}
        </Box>
        <Typography mt={2}>{renderAddressString()}</Typography>
      </CustomizedBox>
      <PurchaseDeliveryAddressModal
        name="customer_details"
        open={openDeliveryAddress}
        handleClose={closeDeliveryAddress}
        viewMode={false}
      />
    </Fragment>
  );
};

export default AddressInfo;
